import { ReportTableColumn } from '../models/report-table-column.model';

export const DetailDataTable: ReportTableColumn[] = [
  {
    displayName: 'Division',
    columnName: 'division',
    propertyName: 'Division',
    width: 'medium',
  },
  {
    displayName: 'Customer Name',
    columnName: 'customer-name-detail',
    propertyName: 'Customer Name',
    width: 'wide',
  },
  {
    displayName: 'Invoice Number',
    columnName: 'invoice-number',
    propertyName: 'Invoice Number',
    width: 'medium',
  },
  {
    displayName: 'Invoice Date',
    columnName: 'invoice-date',
    propertyName: 'Invoice Date',
    width: 'medium',
  },
  {
    displayName: 'Credit Memo #',
    columnName: 'credit-memo-number',
    propertyName: 'Credit Memo Number',
    width: 'medium',
  },
  {
    displayName: 'Order #',
    columnName: 'order-number',
    propertyName: 'Order Number',
    width: 'medium',
  },
  {
    displayName: 'Ship Date',
    columnName: 'ship-date',
    propertyName: 'Ship Date',
    width: 'wide',
  },
  {
    displayName: 'Trans. Type',
    columnName: 'transaction-type',
    propertyName: 'Trans. Type',
    width: 'medium',
  },
  {
    displayName: 'Product #',
    columnName: 'product-number',
    propertyName: 'Product Number',
    width: 'medium',
  },
  {
    displayName: 'Product Description',
    columnName: 'product-description',
    propertyName: 'Product Description',
    width: 'wide',
  },
  {
    displayName: 'Brand',
    columnName: 'brand',
    propertyName: 'Brand',
    width: 'narrow',
  },
  {
    displayName: 'Pack',
    columnName: 'pack',
    propertyName: 'Pack',
    width: 'medium',
  },
  {
    displayName: 'Manufacturer Name',
    columnName: 'manufacturer-name',
    propertyName: 'Manufacturer Name',
    width: 'wide',
  },
  {
    displayName: 'Manufacturer Product #',
    columnName: 'manufacturer-product-number',
    propertyName: 'Manufacturer Product Number',
    width: 'medium',
  },
  {
    displayName: 'Contracted',
    columnName: 'contracted',
    propertyName: 'Contracted',
    width: 'medium',
  },
  {
    displayName: 'Cases Ordered',
    columnName: 'cases-ordered',
    propertyName: 'Cases Ordered',
    width: 'narrow',
    headerTextAlign: 'right',
    textAlign: 'right',
  },
  {
    displayName: 'Cases Shipped',
    columnName: 'cases-shipped',
    propertyName: 'Cases Shipped',
    width: 'narrow',
    headerTextAlign: 'right',
    textAlign: 'right',
  },
  {
    displayName: 'Eaches Ordered',
    columnName: 'eaches-ordered',
    propertyName: 'Eaches Ordered',
    width: 'narrow',
    headerTextAlign: 'right',
    textAlign: 'right',
  },
  {
    displayName: 'Eaches Shipped',
    columnName: 'eaches-shipped',
    propertyName: 'Eaches Shipped',
    width: 'narrow',
    headerTextAlign: 'right',
    textAlign: 'right',
  },
  {
    displayName: 'Units Price',
    columnName: 'units-price',
    propertyName: 'Units Price',
    width: 'medium',
    headerTextAlign: 'right',
    textAlign: 'right',
  },
  {
    displayName: 'Extended Price',
    columnName: 'extended-price',
    propertyName: 'Extended Price',
    width: 'wide',
    headerTextAlign: 'right',
    textAlign: 'right',
  },
  {
    displayName: 'Sales Tax',
    columnName: 'sales-tax',
    propertyName: 'Sales Tax',
    width: 'narrow',
    headerTextAlign: 'right',
    textAlign: 'right',
  },
  {
    displayName: 'Product Allowance',
    columnName: 'product-allowance',
    propertyName: 'Product Allowance',
    width: 'medium',
    headerTextAlign: 'right',
    textAlign: 'right',
  },
  {
    displayName: 'Product Allowance Description',
    columnName: 'product-allowance-description',
    propertyName: 'Product Allowance Desc',
    width: 'wide',
  },
  {
    displayName: 'Brand Type',
    columnName: 'brand-type',
    propertyName: 'Brand Type',
    width: 'narrow',
  },
  {
    displayName: 'Pricing UOM',
    columnName: 'pricing-uom',
    propertyName: 'Pricing UOM',
    width: 'narrow',
  },
  {
    displayName: 'Catch Wght Ind',
    columnName: 'catch-wght-ind',
    propertyName: 'Catch Wght Ind',
    width: 'narrow',
  },
  {
    displayName: 'Net Wght Shipped',
    columnName: 'net-wght-shipped',
    propertyName: 'Net Wght Shipped',
    width: 'medium',
    headerTextAlign: 'right',
    textAlign: 'right',
  },
  {
    displayName: 'Proprietary Product',
    columnName: 'proprietary-product',
    propertyName: 'Proprietary Product',
    width: 'narrow',
  },
  {
    displayName: 'Cust Prod # / GL Code',
    columnName: 'cust-prod-number',
    propertyName: 'Cust Prod # / GL Code',
    width: 'wide',
  },
];
